import $ from 'jquery';
import Swiper from 'swiper/swiper-bundle.min';
import { breakpoint } from '../variables/variables.js';

$( () => {
	if ( ! $( '.gallery' ).length ) {
		return;
	}

	// Галерея
	const $current = $( '.gallery .counter__current' );

	function setCurrent( swiper ) {
		const PER_ROW = innerWidth <= breakpoint.TABLET ? 1 : 3;
		let   current = Math.min( swiper.activeIndex + PER_ROW, swiper.slides.length );

		if ( swiper.slides.length <= PER_ROW ) {
			$current.parent().hide();
		} else {
			$current.parent().show();
		}

		if ( current < 10 ) {
			current = '0' + current;
		}

		$current.text( current );
	}

	new Swiper( '.gallery .swiper', {
		slidesPerView: 'auto',
		navigation: {
			nextEl: '.gallery .swiper-button-next',
			prevEl: '.gallery .swiper-button-prev',
		},
		on: {
			init:              setCurrent,
			resize:            setCurrent,
			activeIndexChange: setCurrent,
		}
	} );
} );
